import "../style/Error.scss"

function Error() {
	return (
		<div className="error">
			<div
				className="error__background"
				style={{
					backgroundImage:
						"url(https://firebasestorage.googleapis.com/v0/b/xposed-837fc.appspot.com/o/predefined%2Fnot-found.png?alt=media&token=e99e9ec8-ed73-4229-b106-43dccd52f548)",
				}}
			>
				<div className="error__container">
					<span>Oops, pagina accesată nu există.</span>
				</div>
			</div>
		</div>
	)
}

export default Error
